/**
 * UserRegisterPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Select, Input, Button, Checkbox, DatePicker, Radio, Spin } from 'antd';
import Formatter from 'utils/Formatter';
import { openAddressModal } from 'utils/DaumAPIManager';
import dayjs from 'dayjs';

const UserRegisterPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    grades,
    inputValue,
    isLoading,
    privacy,
    onChange,
    onSubmit,
    onDuplicateCheck,
    onChecked,
    onClose,
    duplicateCheck,
  } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '회원등급',
      required: true,
      form: [
        {
          input: (
            <Select
              size="large"
              value={inputValue?.grade_id}
              options={grades?.map((grade) => ({
                label: grade?.grade_name,
                value: grade?.grade_id,
              }))}
              placeholder="등급을 선택하세요."
              onChange={(e) => onChange('grade_id', e)}
            />
          ),
        },
      ],
    },
    {
      label: '이름',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="이름 입력"
              value={inputValue?.user_name}
              onChange={(e) => onChange('user_name', e.target.value)}
            />
          ),
        },
      ],
    },
    {
      label: '아이디',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="아이디 입력"
              value={inputValue?.user_account}
              onChange={(e) => onChange('user_account', e.target.value)}
              disabled={duplicateCheck?.user_account}
            />
          ),
        },
        {
          input: (
            <Button
              size="large"
              onClick={() => onDuplicateCheck('user_account')}
              disabled={duplicateCheck?.user_account}
            >
              중복확인
            </Button>
          ),
        },
      ],
    },
    {
      label: '비밀번호',
      required: true,
      form: [
        {
          input: (
            <Input.Password
              size="large"
              placeholder="비밀번호 입력"
              value={inputValue.password}
              onChange={(e) => onChange('password', e.target.value)}
            />
          ),
        },
      ],
      message: (
        <p>
          * 비밀번호는 영문,숫자, 특수문자 모두 조합하여 8~20자리로 입력하셔야
          합니다.
          <br />
          (10자리 이상이면 2종류 이상 조합, 미만이면 3종류 모두 조합)
        </p>
      ),
    },
    {
      label: '휴대폰번호',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="휴대폰번호 '-'없이 입력"
              value={inputValue?.user_phone}
              onChange={(e) =>
                onChange('user_phone', Formatter.hyphen(e.target.value))
              }
              disabled={duplicateCheck?.user_phone}
            />
          ),
        },
        {
          input: (
            <Button
              size="large"
              onClick={() => onDuplicateCheck('user_phone')}
              disabled={duplicateCheck?.user_phone}
            >
              중복확인
            </Button>
          ),
        },
      ],
    },
    {
      label: '생년월일',
      required: true,
      form: [
        {
          input: (
            <DatePicker
              size="large"
              placeholder="생년월일"
              value={inputValue?.user_birthday}
              onChange={(e) => onChange('user_birthday', e)}
            />
          ),
        },
      ],
    },
    {
      label: '성별',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={inputValue?.user_gender}
              options={[
                { label: '남', value: 'M' },
                { label: '여', value: 'F' },
              ]}
              onChange={(e) => onChange('user_gender', e.target.value)}
            />
          ),
        },
      ],
    },
    {
      label: '이메일',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="이메일 입력"
                style={{ width: 300 }}
                value={inputValue.user_email}
                onChange={(e) => onChange('user_email', e.target.value)}
                disabled={duplicateCheck?.user_email}
              />
            </>
          ),
        },
        {
          input: (
            <Button
              size="large"
              onClick={() => onDuplicateCheck('user_email')}
              disabled={duplicateCheck?.user_email}
            >
              중복확인
            </Button>
          ),
        },
      ],
    },
    {
      label: '주소',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="우편번호"
                value={inputValue?.postcode}
                readOnly
              />
              <Button size="large" onClick={() => handleAddressModal()}>
                주소찾기
              </Button>
            </>
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="도로명 주소"
                style={{ width: 295 }}
                value={inputValue?.user_address}
                readOnly
              />
              <Input
                size="large"
                placeholder="상세주소"
                style={{ width: 295 }}
                value={inputValue?.user_address_detail}
                onChange={(e) =>
                  onChange('user_address_detail', e.target.value)
                }
              />
            </>
          ),
        },
      ],
    },
  ];
  const form2 = [
    {
      label: '회원정보 관련 메모',
      form: [
        {
          input: (
            <Input.TextArea
              style={{ height: 160, width: '100%' }}
              value={inputValue?.memo}
              onChange={(e) => onChange('memo', e.target.value)}
            />
          ),
          fullscreen: true,
        },
      ],
    },
  ];
  const form3 = [
    {
      label: '이용약관 동의',
      required: true,
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.terms_of_use}
              onChange={(e) => onChecked('terms_of_use', e.target.checked)}
            >
              이용약관 동의
            </Checkbox>
          ),
        },
      ],
    },
    {
      label: '개인정보 수집 및 이용 동의',
      required: true,
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.terms_of_privacy}
              onChange={(e) => onChecked('terms_of_privacy', e.target.checked)}
            >
              개인정보 수집 및 이용 동의
            </Checkbox>
          ),
        },
      ],
    },
    {
      label: '만 14세 이상입니다',
      required: true,
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.terms_of_age}
              onChange={(e) => onChecked('terms_of_age', e.target.checked)}
            >
              만 14세 이상입니다
            </Checkbox>
          ),
        },
      ],
    },
    {
      label: '마케팅 목적의 개인정보 수집 및 이용 동의',
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.terms_of_marketing}
              onChange={(e) =>
                onChecked('terms_of_marketing', e.target.checked)
              }
            >
              마케팅 목적의 개인정보 수집 및 이용 동의
            </Checkbox>
          ),
        },
      ],
    },
    {
      label: '혜택 및 광고성 정보 수신 동의',
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.terms_of_ad}
              onChange={(e) => onChecked('terms_of_ad', e.target.checked)}
            >
              혜택 및 광고성 정보 수신 동의
            </Checkbox>
          ),
        },
      ],
    },

    {
      label: '마케팅정보 수집 및 활용 동의',
      form: [
        {
          input: (
            <Checkbox
              size="large"
              checked={privacy?.marketing_consent}
              onChange={(e) => onChecked('marketing_consent', e.target.checked)}
            >
              마케팅정보 수집 및 활용 동의
            </Checkbox>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 API
   * --
   */
  const handleAddressModal = () => {
    openAddressModal((res) => {
      const { address, zonecode } = res;

      onChange('user_address', address);
      onChange('postcode', zonecode);
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Spin spinning={isLoading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>회원 등록</Title>

            {/* 기본정보 */}
            <Content
              maxWidth={'100%'}
              padding={20}
              borderRadius={4}
              style={{ marginBottom: 40 }}
            >
              <Title style={{ ...styles.subTitle }}>기본 정보</Title>
              <InputFormTable form={form1} />
            </Content>
            {/* 기본정보 끝 */}

            {/* 부가 정보 */}
            <Content
              maxWidth={'100%'}
              padding={20}
              borderRadius={4}
              style={{ marginBottom: 40 }}
            >
              <Title style={{ ...styles.subTitle }}>부가 정보</Title>
              <InputFormTable form={form2} />
            </Content>
            {/* 부가 정보 끝 */}

            {/* 개인정보 수집/이용 동의 */}
            <Content
              maxWidth={'100%'}
              padding={20}
              borderRadius={4}
              style={{ marginBottom: 40 }}
            >
              <Title style={{ ...styles.subTitle }}>
                개인정보 수집/이용 동의
              </Title>
              <InputFormTable form={form3} />
            </Content>
            {/* 개인정보 수집/이용 동의 끝 */}

            {/* 버튼 */}
            <Content maxWidth={'100%'} backgroundColor={'none'}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  size="large"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                    color: '#FFFFFF',
                  }}
                  onClick={() => onSubmit()}
                >
                  저장
                </Button>
                <Button
                  size="large"
                  style={{ ...styles.button }}
                  onClick={() => onClose()}
                >
                  취소
                </Button>
              </div>
            </Content>
            {/* 버튼 끝 */}
          </Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default UserRegisterPresenter;
